import { render } from "./TelehealthHeader.vue?vue&type=template&id=70e1bd9a&scoped=true&ts=true"
import script from "./TelehealthHeader.vue?vue&type=script&lang=ts"
export * from "./TelehealthHeader.vue?vue&type=script&lang=ts"

import "./TelehealthHeader.vue?vue&type=style&index=0&id=70e1bd9a&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70e1bd9a"]])

export default __exports__